<template>
  <div>
    <div v-for="(item, index) in totalListOrder" :key="index">
      <div
          class="border-item mr-3 ml-3 mb-3"
          v-if="!item.statusOrder && !item.isGroupOrder"
      >
        <div class="d-flex w-100">
          <div
              class="text-left font-weight-bold px-2 py-2"
              style="
              background: #eeeeee;
              border-top-left-radius: 5px;
              border-bottom: 1px solid #828282;
              width: 42%;
            "
          >
            <span
                style="
                cursor: pointer;
                text-decoration: underline;
                color: #3785ee;
              "
                @click="openDetailOrder(item)"
            >{{ item.code }}</span
            >
            - {{ formatPrice(item.totalPrice) }} /
            <span v-if="item.version === ORDER_VERSION.V1"
            >{{ item.paymentType }} /</span
            >
            {{ item.contactStatus.type || "" }}-{{
              item.contactStatus.name || ""
            }}
          </div>
          <div
              class="text-right px-2 py-2"
              style="
              background: #eeeeee;
              border-top-right-radius: 5px;
              border-bottom: 1px solid #828282;
              width: 58%;
            "
          >
            Sale:
            {{ item.user && item.user.fullName ? item.user.fullName : "" }}
            (<span style="font-weight: 500">{{
              formatDateCus(item.createdAt, "DD-MM-YYYY")
            }}</span
          >)
          </div>
        </div>

        <div
            v-for="(product, idx) in item.products"
            class="w-100 px-3 pb-2"
            :key="'product' + idx"
        >
          <div class="py-1 d-flex">
            <div
                :style="{ width: innerWidth > 1440 ? '50%' : '42%' }"
                class="pl-0 py-0"
            >
              <div class="d-flex">
                <div style="width: 8%" class="py-0 pr-2 text-right">
                  <v-icon class="pr-1" color="green"
                  >mdi-book-open-variant</v-icon
                  >
                </div>
                <div style="width: 92%; align-self: center;" class="py-0 font-weight-bold text-left">
                  {{ product.name }}
                </div>
              </div>
            </div>
            <div style="width: 16%" class="pl-0 py-0">
              <div class="d-flex">
                <div class="mr-5">{{ product.quantity }}</div>
                <div
                    v-if="item.version === ORDER_VERSION.V1"
                    style="min-width: 60px"
                >
                  {{ formatPrice(product.intoMoney) }}
                </div>
                <div class="d-flex align-center" v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on"
                           :style="{ color: product.isTransfered ? '#F56C22' : ((product.trialExchangeStatus && product.trialExchangeStatus == 'finished') ? '#279600' : ''),
                                  fontWeight: (product.trialExchangeStatus && product.trialExchangeStatus == 'finished' || product.isTransfered) ? 'bold' : ''}">
                        {{ formatPrice(product.intoMoney) }}
                      </div>
                    </template>
                    <span
                    >Giá gốc:
                      {{
                        formatPrice(
                            Number(product.price) * Number(product.quantity)
                        )
                      }}</span
                    >
                  </v-tooltip>
                  <template v-if="product && product.isTransfered">
                    <v-icon class="mx-1" style="color:#F56C22" size="small">mdi-repeat</v-icon>
                  </template>
                  <v-tooltip v-if="product.trialExchangeStatus && product.trialExchangeStatus == 'finished'" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-icon style="color:#279600" size="small">mdi-check-circle</v-icon>
                      </div>
                    </template>
                    <span>Đã hoàn tất thanh toán</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
            <div style="width: 25%" class="pl-0 py-0 font-weight-bold">
              {{ product.childName }}
            </div>
            <div
                :style="{ width: innerWidth > 1440 ? '9%' : '16%' }"
                class="pl-0 py-0"
            >
              <span v-if="item.version !== ORDER_VERSION.V1">{{
                  product.orderType === 1 ? "Mua mới" : "Gia Hạn"
                }}</span>
              <span v-else>--</span>
            </div>
          </div>
          <div
              v-if="item.version !== ORDER_VERSION.V1"
              class="px-2 d-flex pt-0 w-100 justify-space-between"
          >
            <div
                style="
                border-radius: 4px;
                border: 1px solid #eee;
                background: #f9f9f9;
                width: 40%;
              "
            >
              <div class="d-flex justify-space-between text-left px-1" style="height: 100%;">
                <div class="d-flex">
                  <div class="my-auto d-flex">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="13"
                        viewBox="0 0 12 13"
                        fill="none"
                        class="mx-1"
                    >
                      <path
                          d="M6 11.3C8.64 11.3 10.8 9.14 10.8 6.5C10.8 3.86 8.64 1.7 6 1.7C3.36 1.7 1.2 3.86 1.2 6.5C1.2 9.14 3.36 11.3 6 11.3ZM6 0.5C9.3 0.5 12 3.2 12 6.5C12 9.8 9.3 12.5 6 12.5C2.7 12.5 0 9.8 0 6.5C0 3.2 2.7 0.5 6 0.5ZM6.3 6.98L3.42 8.66L3 7.82L5.4 6.44V3.5H6.3V6.98Z"
                          fill="#666666"
                      />
                    </svg>
                  </div>
                  <div class="my-auto">
                    <div
                        v-if="product.productType == 'sku_duo'"
                        class="text-order-bonus"
                    >
                      {{
                        product.durationType === "day"
                            ? `${formatDateCus(product.endDate, "DD-MM-YYYY")}`
                            : `${product.totalDuration} tháng`
                      }}
                    </div>
                    <div v-else class="text-order-bonus">
                      {{ product.totalDuration }} buổi
                    </div>
                  </div>
                </div>
                <div style="width: 125px;" class="d-flex">
                  <div class="my-auto d-flex">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="13"
                        viewBox="0 0 8 13"
                        fill="none"
                        class="mx-1"
                    >
                      <path
                          d="M0.399902 0.5H7.5999V4.1L5.1999 6.5L7.5999 8.9V12.5H0.399902V8.9L2.7999 6.5L0.399902 4.1V0.5ZM6.3999 9.2L3.9999 6.8L1.5999 9.2V11.3H6.3999V9.2ZM3.9999 6.2L6.3999 3.8V1.7H1.5999V3.8L3.9999 6.2ZM2.7999 2.9H5.1999V3.35L3.9999 4.55L2.7999 3.35V2.9Z"
                          fill="#666666"
                      />
                    </svg>
                  </div>
                  <div
                      v-if="product.pricePolicyDuration"
                      class="my-auto text-order-bonus"
                  >
                    Tặng thêm
                    {{
                      `${product.pricePolicyDuration} ${
                          product.productType == "sku_tutor" ? "buổi" : "tháng"
                      }`
                    }}
                  </div>
                  <div v-else>--</div>
                </div>
              </div>
            </div>
            <div
                style="
                border-radius: 4px;
                border: 1px solid #eee;
                background: #f9f9f9;
                width: 57%;
              "
                class="d-flex text-left px-1"
            >
              <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    class="mx-1 mt-1"
                >
                  <path
                      d="M15.75 8V14C15.75 14.3978 15.592 14.7794 15.3107 15.0607C15.0294 15.342 14.6478 15.5 14.25 15.5H2.25C1.85218 15.5 1.47064 15.342 1.18934 15.0607C0.908035 14.7794 0.75 14.3978 0.75 14V8C0.551088 8 0.360322 7.92098 0.21967 7.78033C0.0790176 7.63968 0 7.44891 0 7.25V5C0 4.60218 0.158035 4.22064 0.43934 3.93934C0.720644 3.65804 1.10218 3.5 1.5 3.5H3.8775C3.795 3.2675 3.75 3.0125 3.75 2.75C3.75 2.15326 3.98705 1.58097 4.40901 1.15901C4.83097 0.737053 5.40326 0.5 6 0.5C6.75 0.5 7.41 0.875 7.8225 1.43V1.4225L8.25 2L8.6775 1.4225V1.43C9.09 0.875 9.75 0.5 10.5 0.5C11.0967 0.5 11.669 0.737053 12.091 1.15901C12.5129 1.58097 12.75 2.15326 12.75 2.75C12.75 3.0125 12.705 3.2675 12.6225 3.5H15C15.3978 3.5 15.7794 3.65804 16.0607 3.93934C16.342 4.22064 16.5 4.60218 16.5 5V7.25C16.5 7.44891 16.421 7.63968 16.2803 7.78033C16.1397 7.92098 15.9489 8 15.75 8ZM2.25 14H7.5V8H2.25V14ZM14.25 14V8H9V14H14.25ZM6 2C5.80109 2 5.61032 2.07902 5.46967 2.21967C5.32902 2.36032 5.25 2.55109 5.25 2.75C5.25 2.94891 5.32902 3.13968 5.46967 3.28033C5.61032 3.42098 5.80109 3.5 6 3.5C6.19891 3.5 6.38968 3.42098 6.53033 3.28033C6.67098 3.13968 6.75 2.94891 6.75 2.75C6.75 2.55109 6.67098 2.36032 6.53033 2.21967C6.38968 2.07902 6.19891 2 6 2ZM10.5 2C10.3011 2 10.1103 2.07902 9.96967 2.21967C9.82902 2.36032 9.75 2.55109 9.75 2.75C9.75 2.94891 9.82902 3.13968 9.96967 3.28033C10.1103 3.42098 10.3011 3.5 10.5 3.5C10.6989 3.5 10.8897 3.42098 11.0303 3.28033C11.171 3.13968 11.25 2.94891 11.25 2.75C11.25 2.55109 11.171 2.36032 11.0303 2.21967C10.8897 2.07902 10.6989 2 10.5 2ZM1.5 5V6.5H7.5V5H1.5ZM9 5V6.5H15V5H9Z"
                      fill="#888888"
                  />
                </svg>
              </div>
              <div v-if="product.campaigns && product.campaigns.length">
                <template v-for="data in product.campaigns">
                  <div
                      v-for="tem in data.orderProductPromotions"
                      :key="tem.campaignCode"
                      class="text-order-bonus"
                  >
                    <div>{{ tem.quantity }} x {{ tem.name }}</div>
                  </div>
                </template>
              </div>
              <div v-else>--</div>
            </div>
          </div>
        </div>

        <div
            v-for="(combo, idx) in item.combos"
            class="w-100 px-3 pb-2"
            :key="'combo' + idx"
        >
          <div class="mx-0 py-1 d-flex w-100">
            <div
                :style="{ width: innerWidth > 1440 ? '50%' : '42%' }"
                class="pl-0 py-0"
            >
              <div class="d-flex">
                <div style="width: 8%" class="py-0 pr-2 text-right">
                  <v-icon class="pr-1" color="green"
                  >mdi-book-open-variant</v-icon
                  >
                </div>
                <div style="width: 92%; align-self: center;" class="py-0 text-left font-weight-bold">
                  {{ combo.name }}
                </div>
              </div>
            </div>
            <div style="width: 16%" class="pl-0 py-0">
              <div class="d-flex">
                <div class="mr-5">{{ combo.quantity }}</div>
                <div
                    v-if="item.version === ORDER_VERSION.V1"
                    style="min-width: 60px"
                >
                  {{ formatPrice(combo.intoMoney) }}
                </div>
                <div class="d-flex align-center" v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on"
                           :style="{ color: combo.isTransfered ? '#F56C22' : ((combo.trialExchangeStatus && combo.trialExchangeStatus == 'finished') ? '#279600' : ''),
                       fontWeight: (combo.trialExchangeStatus && combo.trialExchangeStatus == 'finished' || combo.isTransfered) ? 'bold' : ''}">
                        {{ formatPrice(combo.intoMoney) }}
                      </div>
                    </template>
                    <span
                    >Giá gốc:
                      {{
                        formatPrice(
                            Number(combo.price) * Number(combo.quantity)
                        )
                      }}</span
                    >
                  </v-tooltip>
                  <template v-if="combo && combo.isTransfered">
                    <v-icon class="mx-1" style="color:#F56C22" size="small">mdi-repeat</v-icon>
                  </template>
                  <v-tooltip v-if="combo.trialExchangeStatus && combo.trialExchangeStatus == 'finished'" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-icon style="color:#279600" size="small">mdi-check-circle</v-icon>
                      </div>
                    </template>
                    <span>Đã hoàn tất thanh toán</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
            <div style="width: 25%" class="pl-0 py-0 font-weight-bold">
              {{ combo.childName }}
            </div>
            <div
                :style="{ width: innerWidth > 1440 ? '9%' : '16%' }"
                class="pl-0 py-0"
            >
              <span v-if="item.version !== ORDER_VERSION.V1">{{
                  combo.orderType === 1 ? "Mua mới" : "Gia Hạn"
                }}</span>
              <span v-else>--</span>
              <!-- {{ combo.orderType === 1 ? 'Mua mới' : 'Gia Hạn' }} -->
            </div>
          </div>
          <div
              v-if="item.version !== ORDER_VERSION.V1"
              class="px-2 my-0 d-flex pt-0 w-100"
          >
            <div
                style="
                border-radius: 4px;
                border: 1px solid #eee;
                background: #f9f9f9;
              "
                class="text-left w-100 px-1 py-1"
            >
              <table style="width: 100%">
                <tr v-for="prod in combo.products" :key="prod.id">
                  <td class="text-left">• {{ prod.name }}</td>
                  <td class="text-left">
                    <div class="d-flex">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          class="my-auto"
                      >
                        <path
                            d="M6 10.8C8.64 10.8 10.8 8.64 10.8 6C10.8 3.36 8.64 1.2 6 1.2C3.36 1.2 1.2 3.36 1.2 6C1.2 8.64 3.36 10.8 6 10.8ZM6 0C9.3 0 12 2.7 12 6C12 9.3 9.3 12 6 12C2.7 12 0 9.3 0 6C0 2.7 2.7 0 6 0ZM6.3 6.48L3.42 8.16L3 7.32L5.4 5.94V3H6.3V6.48Z"
                            fill="#666666"
                        />
                      </svg>
                      <div
                          v-if="prod.productType == 'sku_duo'"
                          class="px-1 text-order-bonus"
                      >
                        {{
                          prod.durationType === "day"
                              ? `${formatDateCus(prod.endDate, "DD-MM-YYYY")}`
                              : `${prod.totalDuration} tháng`
                        }}
                      </div>
                      <div v-else class="px-1 text-order-bonus">
                        {{ prod.totalDuration }} buổi
                      </div>
                    </div>
                  </td>
                  <td class="text-left">
                    <div class="d-flex" style="width: 125px;">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="12"
                          viewBox="0 0 8 12"
                          fill="none"
                          class="my-auto mx-1"
                      >
                        <path
                            d="M0.399902 0H7.5999V3.6L5.1999 6L7.5999 8.4V12H0.399902V8.4L2.7999 6L0.399902 3.6V0ZM6.3999 8.7L3.9999 6.3L1.5999 8.7V10.8H6.3999V8.7ZM3.9999 5.7L6.3999 3.3V1.2H1.5999V3.3L3.9999 5.7ZM2.7999 2.4H5.1999V2.85L3.9999 4.05L2.7999 2.85V2.4Z"
                            fill="#666666"
                        />
                      </svg>
                      <div
                          v-if="prod.pricePolicyDuration"
                          class="text-order-bonus px-1"
                      >
                        Tặng thêm
                        {{
                          `${prod.pricePolicyDuration} ${
                              prod.productType == "sku_tutor" ? "buổi" : "tháng"
                          }`
                        }}
                      </div>
                      <div v-else>--</div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div
              v-if="item.version !== ORDER_VERSION.V1"
              cols="12"
              class="px-2 pt-2 d-flex pt-0 w-100"
          >
            <div
                style="
                border-radius: 4px;
                border: 1px solid #eee;
                background: #f9f9f9;
              "
                class="text-left w-100 d-flex px-1 py-1"
            >
              <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    class="mx-1 mt-1"
                >
                  <path
                      d="M15.75 8V14C15.75 14.3978 15.592 14.7794 15.3107 15.0607C15.0294 15.342 14.6478 15.5 14.25 15.5H2.25C1.85218 15.5 1.47064 15.342 1.18934 15.0607C0.908035 14.7794 0.75 14.3978 0.75 14V8C0.551088 8 0.360322 7.92098 0.21967 7.78033C0.0790176 7.63968 0 7.44891 0 7.25V5C0 4.60218 0.158035 4.22064 0.43934 3.93934C0.720644 3.65804 1.10218 3.5 1.5 3.5H3.8775C3.795 3.2675 3.75 3.0125 3.75 2.75C3.75 2.15326 3.98705 1.58097 4.40901 1.15901C4.83097 0.737053 5.40326 0.5 6 0.5C6.75 0.5 7.41 0.875 7.8225 1.43V1.4225L8.25 2L8.6775 1.4225V1.43C9.09 0.875 9.75 0.5 10.5 0.5C11.0967 0.5 11.669 0.737053 12.091 1.15901C12.5129 1.58097 12.75 2.15326 12.75 2.75C12.75 3.0125 12.705 3.2675 12.6225 3.5H15C15.3978 3.5 15.7794 3.65804 16.0607 3.93934C16.342 4.22064 16.5 4.60218 16.5 5V7.25C16.5 7.44891 16.421 7.63968 16.2803 7.78033C16.1397 7.92098 15.9489 8 15.75 8ZM2.25 14H7.5V8H2.25V14ZM14.25 14V8H9V14H14.25ZM6 2C5.80109 2 5.61032 2.07902 5.46967 2.21967C5.32902 2.36032 5.25 2.55109 5.25 2.75C5.25 2.94891 5.32902 3.13968 5.46967 3.28033C5.61032 3.42098 5.80109 3.5 6 3.5C6.19891 3.5 6.38968 3.42098 6.53033 3.28033C6.67098 3.13968 6.75 2.94891 6.75 2.75C6.75 2.55109 6.67098 2.36032 6.53033 2.21967C6.38968 2.07902 6.19891 2 6 2ZM10.5 2C10.3011 2 10.1103 2.07902 9.96967 2.21967C9.82902 2.36032 9.75 2.55109 9.75 2.75C9.75 2.94891 9.82902 3.13968 9.96967 3.28033C10.1103 3.42098 10.3011 3.5 10.5 3.5C10.6989 3.5 10.8897 3.42098 11.0303 3.28033C11.171 3.13968 11.25 2.94891 11.25 2.75C11.25 2.55109 11.171 2.36032 11.0303 2.21967C10.8897 2.07902 10.6989 2 10.5 2ZM1.5 5V6.5H7.5V5H1.5ZM9 5V6.5H15V5H9Z"
                      fill="#888888"
                  />
                </svg>
              </div>
              <div v-if="combo.campaigns && combo.campaigns.length">
                <template v-for="data in combo.campaigns">
                  <div
                      v-for="tem in data.orderProductPromotions"
                      :key="tem.campaignCode"
                      class="text-order-bonus"
                  >
                    <div>{{ tem.quantity }} x {{ tem.name }}</div>
                  </div>
                </template>
              </div>
              <div v-else>--</div>
            </div>
          </div>
        </div>

        <div v-if="item.version === ORDER_VERSION.V2" class="px-2">
          <div class="w-100">
            <div style="width: 100%; height: 1px; background: #bdbdbd"></div>
          </div>
          <div class="d-flex w-100 pt-2">
            <div style="width: 50%" class="px-2">
              <div
                  class="d-flex font-weight-bold"
                  style="color: #666666; font-size: 12px"
              >
                LỊCH SỬ THANH TOÁN
              </div>
            </div>
            <div style="width: 50%" class="px-2">
              <div
                  class="d-flex justify-end font-weight-bold"
                  style="font-size: 12px"
              >
                Tổng tiền đã thanh toán:
                {{
                  item.paidAmount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
              </div>
            </div>
          </div>
          <div v-if="item.receipts && item.receipts.length > 0" class="w-100">
            <div
                v-for="(receipt, index) in item.receipts"
                :key="'receipt' + index"
                class="w-100 py-2"
            >
              <div class="d-flex px-2">
                <div style="width: 72%" class="pt-0">
                  <div class="d-flex align-center">
                    <div
                        v-if="
                        ORDER_RECEIPT_STATUS_MAP.find(
                          (e) => e.value === receipt.status
                        )
                      "
                        class="receipt-status-box mr-3"
                        :class="
                        ORDER_RECEIPT_STATUS_MAP.find(
                          (e) => e.value === receipt.status
                        ).styleClass
                      "
                    >
                      {{
                        ORDER_RECEIPT_STATUS_MAP.find(
                            (e) => e.value === receipt.status
                        ).text
                      }}
                    </div>
                    <div class="text-left" style="line-height: 1.4">
                      {{
                        formatDateCus(receipt.created_at, "HH:mm:ss DD/MM/YYYY")
                      }}
                      <span class="font-weight-bold mx-2">
                        {{ receipt.code }} -
                        {{
                          receipt.amount
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        /
                        {{ receipt.payment_method  == 'MONEY_RECEIPT' ? 'Biên nhận' : receipt.payment_method }}
                      </span>
                    </div>
                  </div>
                </div>
                <div style="width: 28%" class="pt-0">
                  <div class="text-right pr-2" style="line-height: 1.4">
                    Sale: {{ receipt.user ? receipt.user.fullName : "" }}
                  </div>
                </div>
              </div>
              <div
                  class="py-0"
                  v-if="
                  receipt.orderProductTrials &&
                  receipt.orderProductTrials.length > 0
                "
              >
                <div
                    v-for="(trial, index) in receipt.orderProductTrials"
                    :key="'trial' + index"
                    class="px-2 py-1"
                >
                  <div class="d-flex px-2">
                    <div
                        style="width: 42%"
                        class="pt-0 d-flex justify-start text-left"
                    >
                      {{ trial.name }}
                    </div>
                    <div style="width: 25%" class="pt-0 text-center">
                      <template
                          v-if="
                          trial.productType !== PRODUCT_TRIAL_TYPE.SKU_COMBO
                        "
                      >Quy đổi: {{ trial.trailLessons }}
                        {{
                          trial.productType == "sku_duo" ? "(tháng)" : "(buổi)"
                        }}</template
                      >
                      <template v-else>--</template>
                    </div>
                    <div style="width: 33%" class="pt-0 text-right">
                      Tiền quy đổi:
                      {{
                        trial.money && trial.money !== 0
                            ? trial.money
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0"
                      }}
                    </div>
                  </div>
                  <template
                      v-if="trial.productType === PRODUCT_TRIAL_TYPE.SKU_COMBO"
                  >
                    <div class="pt-0 w-full">
                      <div
                          v-for="(itemCombo, index) in trial.items"
                          :key="'itemCombo' + index"
                          class="d-flex px-2 py-1"
                      >
                        <div style="width: 42%" class="pl-4 pt-0 d-flex">
                          <v-icon>mdi-circle-small</v-icon>
                          <div class="text-left">{{ itemCombo.name }}</div>
                        </div>
                        <div
                            style="width: 25%"
                            class="d-flex justify-center pt-0"
                        >
                          Quy đổi: {{ itemCombo.trailLessons }}
                          {{
                            itemCombo.productType ===
                            PRODUCT_TRIAL_TYPE.SKU_TUTOR
                                ? "(buổi)"
                                : "(tháng)"
                          }}
                        </div>
                        <div style="width: 33%" class="d-flex justify-end pt-0">
                          Tiền quy đổi: {{ formatPrice(itemCombo.money) }}
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="py-0 d-flex justify-start pb-2 px-2">
            <span style="font-style: italic; color: #666666;font-size:12px !important"
            >Hiện tại chưa có giao dịch thanh toán nào đã/đang được xử
              lý</span
            >
          </div>
          <div v-if="projectName !== 'ERP'">
            <div
                class="pb-1 text-left px-2"
                v-if="
                item.contactStatus &&
                (item.contactStatus.code === 'T_DATT1P' ||
                  item.contactStatus.code === 'C_DATT1P')
              "
            >
              <v-btn
                  outlined
                  color="#2196F3"
                  small
                  @click="handleRedirectOrder(item)"
                  style="text-transform: none"
              >
                <v-icon left> mdi-plus </v-icon>
                Thanh toán thêm
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- Đơn cọc -->
      <div class="border-item mr-3 ml-3 mb-3" v-if="item.isGroupOrder">
        <div class="border-order" style="width: 100%">
          <div class="mr-0 ml-0 d-flex w-100">
            <div
                class="text-left font-weight-bold px-2 py-2"
                style="
                background: #eeeeee;
                border-top-left-radius: 5px;
                border-bottom: 1px solid #828282;
                width: 67%;
              "
            >
              <span
                  style="
                  cursor: pointer;
                  text-decoration: underline;
                  color: #3785ee;
                "
                  @click="openDetailOrderGroup(item)"
              >{{ item.code }}</span
              >
              - {{ formatPrice(item.totalPrice) }} / Đơn có cọc /
              {{ item.depositLabel }}
            </div>

            <div
                class="text-right px-2 py-2"
                style="
                background: #eeeeee;
                border-top-right-radius: 5px;
                border-bottom: 1px solid #828282;
                width: 33%;
              "
            >
              Sale:
              {{ item.user && item.user.fullName ? item.user.fullName : "" }}
              ({{ formatDateCus(item.createdAt, "DD-MM-YYYY") }})
            </div>
          </div>

          <div
              v-for="(product, idx) in item.listOrders[0].products"
              class="px-3 py-1 d-flex"
              :key="'sub-product' + idx"
          >
            <div style="width: 33%" class="pl-0 py-0">
              <div class="d-flex">
                <div style="width: 8%" class="py-0 pr-2 text-right">
                  <v-icon class="pr-1" color="green"
                  >mdi-book-open-variant</v-icon
                  >
                </div>
                <div
                    style="width: 92%; align-self: center;"
                    class="py-0 px-2 text-left font-weight-bold"
                >
                  {{ product.name }}
                </div>
              </div>
            </div>
            <div style="width: 9%" class="pl-0 py-0">
              {{ product.quantity }}
            </div>
            <div style="width: 16%" class="pl-0 py-0">
              {{ formatPrice(product.intoMoney) }}
            </div>
            <div style="width: 25%" class="pl-0 py-0 font-weight-bold">
              {{ product.childName }}
            </div>
            <div style="width: 16%" class="pl-0 py-0">
              <span v-if="item.version !== ORDER_VERSION.V1">{{
                  product.orderType === 1 ? "Mua mới" : "Gia Hạn"
                }}</span>
              <span v-else>--</span>
            </div>
          </div>

          <div
              v-for="(combo, idx) in item.listOrders[0].combos"
              class="px-3 py-1 d-flex"
              :key="'sub-combo' + idx"
          >
            <div style="width: 33%" class="pl-0 py-0">
              <div class="d-flex">
                <div style="width: 8%" class="py-0 pr-2 text-right">
                  <v-icon class="pr-1" color="green"
                  >mdi-book-open-variant</v-icon
                  >
                </div>
                <div
                    style="width: 92%; align-self: center;"
                    class="py-0 px-2 text-left font-weight-bold"
                >
                  {{ combo.name }}
                </div>
              </div>
            </div>
            <div style="width: 9%" class="pl-0 py-0">{{ combo.quantity }}</div>
            <div style="width: 16%" class="pl-0 py-0">
              {{ formatPrice(combo.intoMoney) }}
            </div>
            <div style="width: 25%" class="pl-0 py-0 font-weight-bold">
              {{ combo.childName }}
            </div>
            <div style="width: 16%" class="pl-0 py-0">
              <span v-if="item.version !== ORDER_VERSION.V1">{{
                  combo.orderType === 1 ? "Mua mới" : "Gia Hạn"
                }}</span>
              <span v-else>--</span>
            </div>
          </div>
        </div>
        <div class="w-100">
          <div class="ml-2 mb-2 w-100" v-if="item.listOrders">
            <div
                style="width: 100%"
                v-for="(itemG, index) in item.listOrders"
                :key="index"
                class="w-100"
            >
              <div class="log-deposit font-weight-bold mt-3">
                <div class="log-deposit-status">
                  <div
                      v-if="itemG.orderType == orderDepositType"
                      class="deposit"
                  >
                    Cọc
                  </div>
                  <div
                      v-if="itemG.orderType == orderFinishType"
                      class="deposit finished"
                  >
                    Hoàn tất
                  </div>
                </div>
                <div class="log-deposit-info">
                  <div class="log-deposit-name">
                    {{ itemG.code }} - {{ formatPrice(itemG.totalPrice) }} /
                    {{ itemG.paymentType }} /
                    {{ itemG.contactStatus.type || "" }}-{{
                      itemG.contactStatus.name || ""
                    }}
                    <v-icon
                        v-if="itemG.orderType == orderDepositType"
                        color="#219653"
                    >mdi-lock</v-icon
                    >
                  </div>
                  <div class="log-deposit-sale">
                    Sale:
                    {{
                      itemG.user && itemG.user.fullName
                          ? itemG.user.fullName
                          : ""
                    }}
                  </div>
                </div>
              </div>
              <div class="log-deposit font-weight-bold">
                <div class="log-deposit-status"></div>
                <div class="log-deposit-info">
                  <div class="log-deposit-name">
                    {{
                      itemG.orderType == orderDepositType
                          ? "Tiền cọc"
                          : "Tiền hoàn tất"
                    }}
                    :
                    <b
                        :style="{
                        color:
                          itemG.orderType == orderDepositType
                            ? '#268A42'
                            : '#BD0188',
                      }"
                    >{{ formatPrice(itemG.totalPrice) }}</b
                    >
                  </div>
                  <div class="log-deposit-sale">
                    {{ formatDateCus(itemG.createdAt, "DD-MM-YYYY") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="projectName !== 'ERP'">
            <div v-if="!item.hasFinishOrder" class="ml-2 mb-1" style="text-align: left;">
              <span
                  @click="toOrderDetail(item.depositOrderId)"
                  class="create-finish-order-btn"
              >Tạo đơn hoàn tất</span
              >
            </div>
          </div>
        </div>
      </div>


      <div class="transfers-order" v-if="item.statusOrder">
        <template v-if="!item.version || item.version === ORDER_VERSION.V1">
          <div class="transfers-order-name">
            CHUYỂN PHÍ <span>bởi {{ item.created_name }}</span>
          </div>
          <div class="transfers-order-info">
            <div class="transfers-order-item">
              <div class="my-3">
                {{ subjectTransfer(item.old_subject_type) }} -
                {{ typeTeacher(item.old_teacher_type) }} - 1:
                {{ item.old_class_type }}
              </div>
              <span>{{ item.number_transfer_lesson }} buổi</span>
              <div v-if="projectName === 'ERP'">
                <v-tooltip bottom min-width="max-content">
                  <template v-slot:activator="{ on }">
                    <div style="cursor: pointer;margin-top: 3px" v-on="on">
                      {{ item.old_product_name }}
                    </div>
                  </template>
                  <div v-if="item && item.old_product_program_group && item.old_product_program_group.length > 0">
                    {{ item.old_product_program_group[0].id + '.'+ item.old_product_program_group[0].name }}
                  </div>
                </v-tooltip>
              </div>
            </div>
            <div
                class="transfers-order-icon mt-5"
                :style="{
              background:
                item.type == PACKAGE_FEE.GIA_SU ? '#58BFDA' : '#6A2C62',
            }"
            >
              <v-icon color="white">mdi-swap-horizontal</v-icon>
            </div>
            <div
                class="transfers-order-item ml-10"
                v-if="item.type == PACKAGE_FEE.GIA_SU"
            >
              <div class="my-3">
                {{ subjectTransfer(item.new_subject_type) }} -
                {{ typeTeacher(item.new_teacher_type) }} - 1:
                {{ item.new_class_type }}
              </div>
              <span>{{ item.number_target_lesson }} buổi</span>
              <div v-if="projectName === 'ERP'">
                <v-tooltip bottom min-width="max-content">
                  <template v-slot:activator="{ on }">
                    <div style="cursor: pointer;margin-top: 3px" v-on="on">
                      {{ item.new_product_name }}
                    </div>
                  </template>
                  <span v-if="item && item.new_product_program_group && item.new_product_program_group.length > 0">
                  {{ item.new_product_program_group[0].id + '.'+ item.new_product_program_group[0].name }}
                </span>
                </v-tooltip>
              </div>
            </div>
            <div
                class="transfers-order-item ml-10"
                v-if="item.type == PACKAGE_FEE.TU_HOC"
            >
              <div class="my-3">GÓI TỰ HỌC</div>
              <span>{{ formatPrice(item.number_target_lesson) }} đ</span>
            </div>
          </div>
        </template>
        <template v-else-if="item.version === ORDER_VERSION.V2">
          <template v-if="item.isDuoTransfer">
            <HistoryTransferDuo
                style="text-align: left"
                :urlERP="urlERP"
                :urlCRM="urlCRM"
                :urlOMS="urlOMS"
                :isConfirm="false"
                :transferFeeDetail="item"
                @showTransferDetail="handleShowTransferDetailDuo"
            />
          </template>
          <template v-else-if="item.isReceiptOrder">
            <HistoryReceiptProduct
                style="text-align: left"
                :urlERP="urlERP"
                :urlCRM="urlCRM"
                :urlOMS="urlOMS"
                :isConfirm="false"
                :transferFeeDetail="item"
                @viewDetailCombo="viewDetailComboReceipt">
            </HistoryReceiptProduct>
          </template>
          <template v-else>
            <TransferTicket
                style="text-align: left"
                :urlERP="urlERP"
                :urlCRM="urlCRM"
                :urlOMS="urlOMS"
                :isConfirm="false"
                :transferFeeDetail="item"
                @showTransferDetail="handleShowTransferDetail">
            </TransferTicket>
          </template>
        </template>
      </div>
    </div>
    <v-dialog width='90vw' v-model="isShowDetailTransferFeeDuo">
      <TransferFeeDuo
          v-if="isShowDetailTransferFeeDuo"
          :is-detail="true"
          :id-transfer="transferIdDuo"
          :urlERP="urlERP"
          :urlCRM="urlCRM"
          :urlOMS="urlOMS"
          @close="isShowDetailTransferFeeDuo = false"
      ></TransferFeeDuo>
    </v-dialog>
    <v-dialog width="1400" v-model="isShowDetailTransferFee">
      <TransferFeeDetail
          v-if="isShowDetailTransferFee"
          :is-detail="true"
          :is-check-authorization-transfer-odd-lesson="isCheckAuthorizationTransferOddLesson"
          :is-check-authorization-transfer-deposit="isCheckAuthorizationTransferDeposit"
          :idTransfer="transferId"
          :urlERP="urlERP"
          :urlCRM="urlCRM"
          :urlOMS="urlOMS"
          @close="isShowDetailTransferFee = false"
      ></TransferFeeDetail>
    </v-dialog>
    <v-dialog
        v-if="isShowDetailCb"
        v-model="isShowDetailCb"
        persistent
        max-width="750"
    >
      <DetailComboSubModule
          :product-combo="listProductCombo"
          :is-detail="true"
          @onSavePrice="() => (isShowDetailCb = false)"
      />
    </v-dialog>
  </div>
</template>

<script>
import TransferFeeDetail from "../components/transfer-fee/TransferFeeDetail.vue";
import TransferTicket from "../../../ShareModules/src/components/transfer-fee/TransferTicket.vue";
import HistoryTransferDuo from "../components/transfer-fee-duo/HistoryTransferDuo.vue";

import moment from "moment";
import {
  ORDER_VERSION,
  ORDER_RECEIPT_STATUS_MAP,
  PRODUCT_TRIAL_TYPE,
  ORDER_FINISH_TYPE,
  ORDER_DEPOSIT_TYPE,
  PACKAGE_FEE,
  SUBJECTS_SORT_CLASS,
  LOAI_GIAOVIEN,
} from "./utils/constants.js";
import TransferFeeDuo from "../components/transfer-fee-duo/index.vue";
import HistoryReceiptProduct from "../../../ShareModules/src/components/transfer-fee/HistoryReceiptProduct.vue";
import DetailComboSubModule from "../../../ShareModules/src/components/transfer-fee/DetailComboSubModule.vue";
export default {
  components: {DetailComboSubModule, HistoryReceiptProduct, TransferFeeDuo, HistoryTransferDuo, TransferTicket, TransferFeeDetail},
  props: {
    isCheckAuthorizationTransferDeposit: {
      type: Boolean,
      default: false,
    },
    isCheckAuthorizationTransferOddLesson: {
      type: Boolean,
      default: false,
    },
    urlERP: {
      type: String,
      default: process.env.VUE_APP_SORT_CLASS,
    },
    urlOMS: {
      type: String,
      default: process.env.VUE_APP_API_OMS,
    },
    urlCRM: {
      type: String,
      default: process.env.VUE_APP_API_ERP,
    },
    totalListOrder: {
      type: Array,
      default: () => [],
    },
    projectName: {
      type: String,
      default: "CRM",
    },
  },
  data() {
    return {
      listProductCombo: [],
      isShowDetailCb: false,
      transferId: '',
      transferIdDuo: '',
      isShowDetailTransferFee: false,
      isShowDetailTransferFeeDuo: false,
      ORDER_VERSION,
      ORDER_RECEIPT_STATUS_MAP,
      PRODUCT_TRIAL_TYPE,
      orderFinishType: ORDER_FINISH_TYPE,
      orderDepositType: ORDER_DEPOSIT_TYPE,
      PACKAGE_FEE,
      SUBJECTS_SORT_CLASS,
      LOAI_GIAOVIEN,
    };
  },
  computed: {
    innerWidth() {
      return window.innerWidth;
    },
  },
  methods: {
    viewDetailComboReceipt(data) {
      this.listProductCombo = data;
      this.isShowDetailCb= true
    },
    handleShowTransferDetail(id) {
      this.transferId = id;
      this.isShowDetailTransferFee = true;
    },
    handleShowTransferDetailDuo(id) {
      this.transferIdDuo = id;
      this.isShowDetailTransferFeeDuo = true;
    },
    formatPrice(value, endFix = "") {
      const valueABS = Math.abs(value);
      if (isNaN(valueABS)) return value;
      if (valueABS > -1000 && valueABS < 1000) {
        return value;
      }
      const valueNumber = Intl.NumberFormat("en-US").format(valueABS);
      if (Number(value) < 0) {
        return `-${valueNumber}`;
      }
      if (endFix) {
        return valueNumber + endFix;
      }
      return valueNumber;
    },
    formatDateCus(date, format) {
      if (date) {
        return moment(date).format(format);
      }
      return "";
    },
    handleRedirectOrder(item) {
      this.$emit("redirectOrder", item);
    },
    toOrderDetail(orderId) {
      this.$emit("toOrderDetail", orderId);
    },
    openDetailOrder(item) {
      this.$emit("openDetailOrder", item);
    },
    openDetailOrderGroup(item) {
      this.$emit("openDetailOrderGroup", item);
    },
    typeTeacher(id) {
      let typeTeacher;
      LOAI_GIAOVIEN.map((s) => {
        if (s.id == id) {
          return (typeTeacher = s.name);
        }
      });
      return typeTeacher;
    },
    subjectTransfer(id) {
      let subject;
      SUBJECTS_SORT_CLASS.map((s) => {
        if (s.id == id) {
          return (subject = s.name);
        }
      });
      return subject;
    },
  },
};
</script>
<style lang="scss" scoped>
.border-item {
  border: #9c9c9c 1px solid;
  border-radius: 5px;
}
.border-order {
  border-bottom: #9c9c9c 1px solid;
  border-radius: 5px;
}
.transfers-order {
  background: #f1f7ff;
  margin: 16px 16px 26px 14px;
  border-radius: 6px;
  padding: 12px;
  .transfers-order-name {
    color: black;
    font-weight: 700;
    text-align: left;
    span {
      color: #828282;
    }
  }
  .transfers-order-info {
    display: flex;
    width: 100%;
    text-align: left;
    .transfers-order-item {
      color: #6a2c62;
      font-weight: 700;
      width: 50%;
      span {
        color: #333333;
      }
    }
    .transfers-order-icon {
      width: 23px;
      height: 23px;
      text-align: center;
      background: #6a2c62;
    }
  }
}
.text-order-bonus {
  color: #666;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 400;
}
table {
  td {
    padding: 0 6px;
    font-size: 12px;
    height: 24px !important;
  }
}
.receipt-status-box {
  min-width: 0 !important;
  width: fit-content !important;
  font-size: 10px !important;
  font-weight: 700;
  padding: 2px 13px;
  color: white;
  border-radius: 3px;
  line-height: 15.806px; /* 175.627% */
}
.deposit {
  background: #268A42 ;
  color: white;
  border-radius: 3px;
  font-weight: bold;
  width: 65px;
  text-align: center;
}
.deposit.finished {
  background: #6A2C62;
}
.create-finish-order-btn {
  display: inline-block;
  padding: 0px 15px;
  background: #2F80ED;
  border-radius: 3px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  font-size: 12px;
}
.log-deposit {
  display: flex;
  line-height: 1.75em;
  font-size: 12px;
}
.log-deposit-status {
  width: 85px;
}
.log-deposit-info {
  display: flex;
  width: calc(100% - 85px);
  justify-content: space-between;
  margin-right: 28px;
}
</style>
